var _defs, _path, _g, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path8, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _path9, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _path10, _path11, _path12, _path13, _path14, _path15, _circle, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b1d80de4-06cb-4b2d-9c4c-b14d42818646",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1009.54,
    height: 750.39,
    viewBox: "0 0 1009.54 750.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fd95d79a-5cd9-41a5-a6ba-ef65272c784a",
    x1: 361.1,
    y1: 819.7,
    x2: 361.1,
    y2: 219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "in progress") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M681.78,180c-64.72-1.67-126.36-17.19-185.22-34.17S379.4,110,316.23,101c-40.63-5.79-87.1-6.61-119.83,9.58C164.89,126.14,154.71,153,149.24,178c-4.12,18.77-6.54,38.52,4.74,56.09,7.84,12.2,21.74,22.45,31.36,34.14,33.47,40.66,9.81,90.79-26.45,130.49-17,18.62-36.75,36.38-49.88,56.21s-19.2,42.53-7.71,62.76c11.38,20,38.51,35.09,67.9,45.68,59.69,21.51,130,27.66,198.61,31.15,151.83,7.72,304.46,4.37,456.69,1,56.34-1.24,112.92-2.49,168.34-9,30.78-3.59,62.55-9.3,84.9-23.07,28.36-17.48,35.39-47.08,16.38-69-31.88-36.77-120-45.91-142.31-85.37-12.26-21.72.33-45.91,18.16-66.06,38.24-43.21,102.33-81.12,105.7-130.52,2.32-33.92-28.49-67.9-76.13-83.95-49.93-16.82-119.18-14.71-156,13.14C805.59,170.4,738.93,181.44,681.78,180Z",
    transform: "translate(-95.23 -74.8)",
    fill: "#35979C",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1034,253.58s-11.28-4.58-47.16,11.88-40.36,14.37-49.65,11.85-14.47-3.11-24.43-16.85c0,0-7-38.07-13.82-44s-35.68,3.37-35.68,3.37S828.64,227.79,822,181.5c0,0,4.68-34.88-1.7-45.59,0,0,12.88,5.55,34.12-3.41s38.24,9.66,38.24,9.66,5.36,13.87,4.8,22.13,2.83,11.38,13,7.38c0,0,5-7.08-2.07-18.78s-12.08-20.42-10.11-29.51,7.62-21.68,25.79-28S966.93,87.88,978.78,83s14.71-8.15,14.71-8.15-7.29,7.31,9.89,38.27,6.23,44.41,6.23,44.41-9.14,21.78-49.48,20c0,0-38.87,1.42-17.68,17.9,0,0,13.57-2.76,33.87-9.21s34.93,20.17,38.57,38.69S1034,253.58,1034,253.58Z",
    transform: "translate(-95.23 -74.8)",
    fill: "#35979C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.76,98.29l.21-.06c1.56,5.91-15.81,29.65-30.66,48.53l-.17-.13C972.08,120,983,102.83,981.76,98.29Z",
    transform: "translate(-95.23 -74.8)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.44,146.24l.09.24c-11.86,15.08-26.78,33.08-38.72,46.41-1.14,1.27-2.27,2.6-3.35,4l-.35-.27c1.1-1.37,2.23-2.71,3.37-4C924.42,179.27,939.59,161.31,951.44,146.24Z",
    transform: "translate(-95.23 -74.8)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.4,196.22l.24.4c-21.73,27.13-23.17,69.25-23.22,69.62L881.84,261C881.89,260.58,887.52,223.53,909.4,196.22Z",
    transform: "translate(-95.23 -74.8)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.81,238.87s-25.62-13.32-45.59-8.54-64.92-16.9-64.92-16.9-19.09-7.75-22.93-16.59c0,0-13.09-13.85-13.84-21S848,150.65,839.72,150",
    transform: "translate(-95.23 -74.8)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.1,251.69s-12.9-8.69-11.4-18.83",
    transform: "translate(-95.23 -74.8)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.31,262.92s-18.46-6.7-20.31-33",
    transform: "translate(-95.23 -74.8)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.53,269.72s-17.64-14.63-11.78-40.2",
    transform: "translate(-95.23 -74.8)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.74,262.57s-11.74-24.63-1.29-40.65",
    transform: "translate(-95.23 -74.8)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.11,222.63s-13.35,4.24-10.48,11.26",
    transform: "translate(-95.23 -74.8)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993,198.41s-17.86,5.66-18.28,30.93",
    transform: "translate(-95.23 -74.8)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.1,192.58S951.85,212.64,953,230.87",
    transform: "translate(-95.23 -74.8)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.64,200.45s-16.15,15.43-14.09,24",
    transform: "translate(-95.23 -74.8)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.9,195s-15.14,2.71-17.25-2.26",
    transform: "translate(-95.23 -74.8)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.23,176.72s7.65,10.13,9.62,7.86",
    transform: "translate(-95.23 -74.8)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.05,170.31s-38.16,2.77-46.79-8.73",
    transform: "translate(-95.23 -74.8)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.2,125.68s17.91,38.43,30.91,43.33",
    transform: "translate(-95.23 -74.8)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921,107.37s11,35.35,24.62,46.39",
    transform: "translate(-95.23 -74.8)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.11,141.14s-29,12.45-46.44-.15",
    transform: "translate(-95.23 -74.8)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.84,99.83s6.63,26,15.56,32.27",
    transform: "translate(-95.23 -74.8)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.73,112s-16.31,6.17-22.4,1.44",
    transform: "translate(-95.23 -74.8)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.26,185.21s0,22.65-6.17,24.26",
    transform: "translate(-95.23 -74.8)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.84,214.56s24.5,2.1,35.79-10.54",
    transform: "translate(-95.23 -74.8)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.94,158.45s-5.92,23-22.27,29.16",
    transform: "translate(-95.23 -74.8)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.15,190.36s17.34,6,32.25-9.32",
    transform: "translate(-95.23 -74.8)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.67,138.7s-1.64,19.51-12.25,28.64",
    transform: "translate(-95.23 -74.8)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.81,160.63s14.39.09,17.76-4.59",
    transform: "translate(-95.23 -74.8)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.87,
    cy: 734.89,
    rx: 218,
    ry: 15.5,
    fill: "#35979C",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M484.39,725.3c3-5.39,6.59-10.47,9.49-15.93,2.65-5,4.72-10.3,7.11-15.44,4.09-8.8,9.13-17.12,13.72-25.68,3-5.61,5.9-11.72,5.32-18.06-.55-6-4.07-11.2-5.43-17-5.54-23.81-18.87-45.67-27-68.7-2.08-5.84-4.1-11.72-6.7-17.36-5-10.85-12-20.6-19-30.27a85.48,85.48,0,0,0-8.4-10.44c-2.51-2.51-5.33-4.72-7.61-7.44-4.7-5.6-6.9-13.66-12.78-18-.1.26-.21.51-.32.77C428.58,471,414.46,463.91,406.27,455a157.44,157.44,0,0,1-13.13-17.25l-17.83-25.77c-3.07-4.44-6.2-9-7.44-14.29-1.52-6.38-.11-13.18-1.61-19.56a24.67,24.67,0,0,0-5.45-10.36c.17-.05.35-.12.53-.16,3.4-.91,7-1.07,10.37-1.88,7.35-1.75,13.74-6.45,21.06-8.33,3.74-1,7.73-1.2,11.12-3a9.24,9.24,0,0,0,4.3-9.82c-2.37-12.55,4.25-25.27,3.13-38-.3-3.52-1.2-6.95-1.78-10.44-1.35-8.1-1.1-16.4-.62-24.62a52,52,0,0,1,8.15-10.13c4.5-4.34,9.87-8,13-13.43,2.73-4.81,3.39-10.62,2.7-16.12-.49-4-1.85-8.21-5-10.64s-7.67-2.61-11.48-1.34c-.53.17-1.05.38-1.56.6a13.11,13.11,0,0,0-10.34-.6c-3.8,1.26-7.06,3.77-10.12,6.38a23.13,23.13,0,0,0-4.72,5c-1.93,3-2.49,6.7-3.22,10.23a100,100,0,0,1-6.75,19.79c-.54,1.12-2,3.13-3.18,5.05l-2.14-.44c-.93,8.91-8.39,15.45-12.93,23.15-2.21,3.74-3.76,7.83-5.75,11.7a113.41,113.41,0,0,1-7.59,12.17q-4.05,6-8.11,11.89a169,169,0,0,1-11,14.88c-3.67-.3-7.34-.57-11-.63a89.29,89.29,0,0,0-18.31,1.63,51,51,0,0,1-.65-6.41c0-.13,0-.26,0-.39,0-.52.06-1.14.13-1.81a37,37,0,0,0-1.77-62.6,26.91,26.91,0,0,0,.38-3.4c0-.67,0-1.35,0-2,0-.34,0-.68-.07-1a13.22,13.22,0,0,0-.34-2c-.08-.32-.17-.64-.28-1a9.45,9.45,0,0,0-.83-1.8.86.86,0,0,0-.07-.1c-.13-.21-.26-.42-.41-.62s-.13-.16-.19-.24a4.78,4.78,0,0,0-.34-.42l-.25-.26c-.11-.12-.22-.24-.34-.35l-.28-.25-.35-.31-.32-.24-.36-.27-.35-.23-.36-.23c-.12-.08-.25-.15-.38-.22l-.37-.21-.4-.2-.37-.18-.44-.19-.36-.16-.48-.18-.34-.13-.52-.18-.31-.1-.57-.18-.27-.08-.62-.17-.24-.07-.65-.16-.19-.05-.72-.16-.12,0-1.06-.23q-6.57-1.35-13.22-2.33c-3.63-.54-7.35-1-10.93-.19-4.94,1.1-9.06,4.44-13.68,6.51-5.46,2.46-11.52,3.11-17.34,4.46s-11.81,3.66-15.46,8.43c-2.78,3.64-3.89,8.27-4.72,12.78-6.92,37.64.54,76.25,1.95,114.51.55,14.89-.12,30.81-8.56,43l24.58-.65c1.18,0,2.37-.07,3.57-.14s2.4-.16,3.58-.3a23.68,23.68,0,0,0,8.91-2.67,15.37,15.37,0,0,0,3.47-2.7c3.34-3.44,5.12-8.25,6.75-12.85.55-1.55,1.1-3.12,1.59-4.7.2-.66.39-1.32.56-2l.08-.32.28.13c1,1.88,2.13,3.72,3.33,5.5,4.29,6.32,9.73,11.72,15.13,17.09,10.73,10.65,21.7,21.49,35.15,28.33,4.54,2.29,9.45,4.22,12.91,8,1.7,1.83,3.17,4.18,5.58,4.81,1.5.39,3.15,0,4.58.64,2.1.88,2.87,3.41,3.84,5.49s3.16,4.2,5.24,3.25a10.51,10.51,0,0,0,3.92,10.43,7.66,7.66,0,0,1,2.54,2.28,8.29,8.29,0,0,1,.52,2.68,10.59,10.59,0,0,0,3.79,6.49c-1.95,3.23-.39,7.86-.34,11.89,0,3.38-1.11,6.64-1.87,9.93-2.21,9.65-1,19.75.8,29.48,1,5.37,2.27,10.93,5.77,15.1,1.14,1.35,2.5,2.52,3.7,3.83a35.6,35.6,0,0,1,5.65,8.61,67.5,67.5,0,0,1,6.13,19.64,35.76,35.76,0,0,0,2.9,9.9c2.19,4.78.19,10.66,2.15,15.54.89,2.19,2.53,4.06,3.06,6.35.75,3.33-1,6.66-1.47,10.05-1.14,7.94,4.59,15.31,5.11,23.31a1.84,1.84,0,0,1-.28,1.35c-.39.44-1.06.43-1.59.68-1,.48-1.27,1.83-1.59,2.95s-1.22,2.39-2.33,2.05c-16.43,8.79-33.44,16.91-49.87,25.7l-7.5,4-40.11,21.43a2.9,2.9,0,0,0-1.61,2.62c0,.48.06,1,.1,1.45-2.81.7-5.51,1.54-7.43,1.89-.79.15-1.58.3-2.36.47a2.52,2.52,0,0,0,.36-1,2,2,0,0,0-1.77-2,6.41,6.41,0,0,0-2.89.38,42.15,42.15,0,0,1-7,1.29c-2.81.27-5.67.26-8.39,1s-5.4,2.39-6.5,5a12.13,12.13,0,0,0-.72,4.72,72.25,72.25,0,0,0,2.18,18.34,1.56,1.56,0,0,0,.73,1.17c.35.14.77,0,1.12.16a1.5,1.5,0,0,1,.65.82c1.68,3.82,2.07,8.08,2.52,12.24q1,9.25,2.53,18.45c.6,3.58,1.34,7.32,3.67,10.08,2.56,3,6.61,4.33,10.52,4.86,8.25,1.11,16.58-.56,24.72-2.27,1.52-.32,3.15-.71,4.17-1.89a4.71,4.71,0,0,0,1-3.33c-.19-4.11-3.93-7-7.33-9.31L284,791.56a2,2,0,0,1-1-2.26l.3-6.07-.9,0c1-4.28,2.61-8.39,5.76-11.33,2.17-2,5-3.4,7.27-5.22a18,18,0,0,0,10.11,3.71c6-8.08,14.45-13.58,22.9-19a224,224,0,0,1,21.25-11.86q8.86-4.38,18-8.21c8.6-3.62,17.36-6.85,26.13-10,5.85-2.1,11.75-4.17,17.14-7.27,14-8.09,23.89-24.24,22-40.41-2.38-20.4,2.71-41.66,2.37-62.2-.1-6-.32-12-2.14-17.75a9.48,9.48,0,0,1,1.19,1c3.64,3.4,4.52,8.8,8,12.68,2.71,3.05,6.83,5,8.47,8.72,1.25,2.85,1.07,6.7,3.68,8.34.74.47,1.62.67,2.36,1.13a7.9,7.9,0,0,1,2.19,2.37c2.77,3.95,5.64,8.18,5.94,13,.13,1.91-.05,4.12,1.35,5.41.4.37.91.64,1.12,1.14.44,1-.72,2.06-.92,3.17-.29,1.54,1.23,2.71,2.17,4a6.29,6.29,0,0,1,0,7.41c-8.2,10.65-9.68,25-16.85,36.39-2.48,3.93-5.24,7.65-7.64,11.63-7.38,12.22-11.11,26.26-14.73,40.09a22.15,22.15,0,0,0,6.15,6.86,34,34,0,0,1-6.85,12.65,31.84,31.84,0,0,0-2.26,2.83,5.5,5.5,0,0,0-2.23-1.68,79.23,79.23,0,0,0-2,17.5c0,3.88.53,8.31,3.68,10.55a13.05,13.05,0,0,0,4.09,1.69l6.86,2a7.17,7.17,0,0,0,3.79.37c.81-.23,1.53-.73,2.36-.89a5.79,5.79,0,0,1,2.66.35l5.93,1.73a39.2,39.2,0,0,1,5.86,2.07c1.69.81,3.25,1.86,4.91,2.76a59.33,59.33,0,0,0,8.57,3.52L481.26,816a37.19,37.19,0,0,0,8.86,2.3c2.1.18,4.23,0,6.3.36,1.58.27,3.11.84,4.7,1a12.32,12.32,0,0,0,7.4-2.2,6.61,6.61,0,0,0,2.14-1.93c1.5-2.34.21-5.43-1.25-7.79-2.71-4.38-6.1-8.48-10.57-11-1.81-1-3.77-1.74-5.64-2.66-5.32-2.6-9.33-6.94-14.36-9.91a3.41,3.41,0,0,0-4.31.29c-4.18-2.71-8.7-5.36-11-9.77a22,22,0,0,1-2-6.75c2.35.56,4.72,1,7.11,1.39C472.53,754.25,476.78,738.9,484.39,725.3ZM388.32,298.81c-.2,1.13-.42,2.25-.66,3.37-2,9.39-4.86,19.91-11.4,26.9a25,25,0,0,1-7.38,4.87l-.73.36C372.86,321.73,380.36,310.07,388.32,298.81Z",
    transform: "translate(-95.23 -74.8)",
    fill: "url(#fd95d79a-5cd9-41a5-a6ba-ef65272c784a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M398,243.11c.74-3.49,1.3-7.15,3.23-10.16a23.21,23.21,0,0,1,4.73-5c3.06-2.59,6.33-5.08,10.14-6.34s8.29-1.09,11.49,1.33,4.55,6.59,5.05,10.57c.68,5.47,0,11.23-2.71,16-3.1,5.41-8.48,9-13,13.34a51.62,51.62,0,0,0-8.47,10.56,30.09,30.09,0,0,1-3.86,5.64,7.33,7.33,0,0,1-6.13,2.45c-1.93-.31-3.5-1.65-5-2.93-1.85-1.62-6.83-4.51-7-7.08-.12-2.08,3.77-6.8,4.72-8.75A98.52,98.52,0,0,0,398,243.11Z",
    transform: "translate(-95.23 -74.8)",
    fill: "#fbbebe"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M398,243.11c.74-3.49,1.3-7.15,3.23-10.16a23.21,23.21,0,0,1,4.73-5c3.06-2.59,6.33-5.08,10.14-6.34s8.29-1.09,11.49,1.33,4.55,6.59,5.05,10.57c.68,5.47,0,11.23-2.71,16-3.1,5.41-8.48,9-13,13.34a51.62,51.62,0,0,0-8.47,10.56,30.09,30.09,0,0,1-3.86,5.64,7.33,7.33,0,0,1-6.13,2.45c-1.93-.31-3.5-1.65-5-2.93-1.85-1.62-6.83-4.51-7-7.08-.12-2.08,3.77-6.8,4.72-8.75A98.52,98.52,0,0,0,398,243.11Z",
    transform: "translate(-95.23 -74.8)",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M293,343.06a89.71,89.71,0,0,1,24.57-3c13.83.2,28.07,3.55,41.24-.69a71.54,71.54,0,0,0,9.89-4.29c2.65-1.32,5.35-2.68,7.38-4.84,6.55-6.94,9.37-17.39,11.42-26.72s2.58-18.91,3.11-28.44c3.41,1.59,7,3.16,10.78,2.84s7.55-3.2,7.53-7c-.56,8.83-1,17.77.49,26.49.58,3.46,1.48,6.87,1.79,10.37,1.12,12.64-5.51,25.27-3.14,37.74a9.15,9.15,0,0,1-4.3,9.75c-3.4,1.83-7.4,2.06-11.14,3-7.33,1.87-13.73,6.53-21.09,8.27-3.43.81-7,1-10.38,1.87-4.86,1.28-9.27,4.06-14.22,4.94-3.71.66-7.53.21-11.28.53-3.26.27-6.46,1.13-9.73,1.21-8,.2-15.57-4.33-20.89-10.34S296.34,350.34,293,343.06Z",
    transform: "translate(-95.23 -74.8)",
    fill: "#35979C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M293,343.06a89.71,89.71,0,0,1,24.57-3c13.83.2,28.07,3.55,41.24-.69a71.54,71.54,0,0,0,9.89-4.29c2.65-1.32,5.35-2.68,7.38-4.84,6.55-6.94,9.37-17.39,11.42-26.72s2.58-18.91,3.11-28.44c3.41,1.59,7,3.16,10.78,2.84s7.55-3.2,7.53-7c-.56,8.83-1,17.77.49,26.49.58,3.46,1.48,6.87,1.79,10.37,1.12,12.64-5.51,25.27-3.14,37.74a9.15,9.15,0,0,1-4.3,9.75c-3.4,1.83-7.4,2.06-11.14,3-7.33,1.87-13.73,6.53-21.09,8.27-3.43.81-7,1-10.38,1.87-4.86,1.28-9.27,4.06-14.22,4.94-3.71.66-7.53.21-11.28.53-3.26.27-6.46,1.13-9.73,1.21-8,.2-15.57-4.33-20.89-10.34S296.34,350.34,293,343.06Z",
    transform: "translate(-95.23 -74.8)",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M652.63,355.35a68.84,68.84,0,1,1-68.84,68.83,68.84,68.84,0,0,1,68.84-68.83m0-17a85.84,85.84,0,1,0,85.84,85.83,85.93,85.93,0,0,0-85.84-85.83Z",
    transform: "translate(-95.23 -74.8)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 544.69,
    y: 243.47,
    width: 20.12,
    height: 21.18,
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 689.04,
    y: 330.53,
    width: 20.12,
    height: 21.18,
    transform: "translate(180.31 -386.14) rotate(31)",
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 724.34,
    y: 364.89,
    width: 20.12,
    height: 21.18,
    transform: "translate(611.53 -523.68) rotate(61)",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 724.81,
    y: 461.5,
    width: 20.12,
    height: 21.18,
    transform: "translate(1429.42 24.26) rotate(122)",
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 560.79,
    y: 364.89,
    width: 20.12,
    height: 21.18,
    transform: "translate(1080.79 -16.57) rotate(119)",
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 560.33,
    y: 461.5,
    width: 20.12,
    height: 21.18,
    transform: "translate(573.26 -336.6) rotate(58)",
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 596.1,
    y: 330.53,
    width: 20.12,
    height: 21.18,
    transform: "translate(1206.2 246.52) rotate(149)",
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 544.69,
    y: 434.11,
    width: 20.12,
    height: 21.18,
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 689.04,
    y: 496.66,
    width: 20.12,
    height: 21.18,
    transform: "translate(-256.63 357.71) rotate(-31)",
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 596.1,
    y: 496.66,
    width: 20.12,
    height: 21.18,
    transform: "translate(769.26 1179.44) rotate(-149)",
    fill: "#3f3d56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 449.38,
    y: 340.91,
    width: 24.36,
    height: 18,
    fill: "#3f3d56"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 736.3,
    y: 415.71,
    width: 24.36,
    height: 18,
    transform: "translate(1401.72 774.62) rotate(-180)",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M812.55,231.44a68.84,68.84,0,1,1-68.84,68.83,68.84,68.84,0,0,1,68.84-68.83m0-17a85.84,85.84,0,1,0,85.84,85.83,85.93,85.93,0,0,0-85.84-85.83Z",
    transform: "translate(-95.23 -74.8)",
    fill: "#3f3d56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 704.61,
    y: 119.57,
    width: 20.12,
    height: 21.18,
    fill: "#3f3d56"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 848.96,
    y: 206.62,
    width: 20.12,
    height: 21.18,
    transform: "translate(139.34 -486.21) rotate(31)",
    fill: "#3f3d56"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 884.26,
    y: 240.98,
    width: 20.12,
    height: 21.18,
    transform: "translate(585.55 -727.39) rotate(61)",
    fill: "#3f3d56"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 884.73,
    y: 337.59,
    width: 20.12,
    height: 21.18,
    transform: "translate(1569 -300.93) rotate(122)",
    fill: "#3f3d56"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 720.71,
    y: 240.98,
    width: 20.12,
    height: 21.18,
    transform: "translate(1209.86 -340.41) rotate(119)",
    fill: "#3f3d56"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 720.25,
    y: 337.59,
    width: 20.12,
    height: 21.18,
    transform: "translate(543.35 -530.46) rotate(58)",
    fill: "#3f3d56"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 756.02,
    y: 206.62,
    width: 20.12,
    height: 21.18,
    transform: "translate(1439.38 -65.97) rotate(149)",
    fill: "#3f3d56"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 704.61,
    y: 310.2,
    width: 20.12,
    height: 21.18,
    fill: "#3f3d56"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 848.96,
    y: 372.75,
    width: 20.12,
    height: 21.18,
    transform: "translate(-169.97 422.38) rotate(-31)",
    fill: "#3f3d56"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 756.02,
    y: 372.75,
    width: 20.12,
    height: 21.18,
    transform: "translate(1130.07 1031.68) rotate(-149)",
    fill: "#3f3d56"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 609.29,
    y: 217,
    width: 24.36,
    height: 18,
    fill: "#3f3d56"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 896.21,
    y: 291.8,
    width: 24.36,
    height: 18,
    transform: "translate(1721.56 526.8) rotate(-180)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M492.67,226.14c.81,0,1.62,0,2.43,0a68.84,68.84,0,0,1-2.34,137.64c-.81,0-1.62,0-2.44,0a68.84,68.84,0,0,1,2.35-137.64m0-17h0a85.84,85.84,0,0,0-2.94,171.63c1,0,2,.05,3,.05a85.84,85.84,0,0,0,2.93-171.63c-1,0-2-.05-3-.05Z",
    transform: "translate(-95.23 -74.8)",
    fill: "#3f3d56"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 483.31,
    y: 189.04,
    width: 20.12,
    height: 21.18,
    transform: "translate(-88.01 -91.8) rotate(1.99)",
    fill: "#3f3d56"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 531.97,
    y: 202.99,
    width: 20.12,
    height: 21.18,
    transform: "translate(108.44 -335.49) rotate(32.99)",
    fill: "#3f3d56"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 566.07,
    y: 238.55,
    width: 20.12,
    height: 21.18,
    transform: "translate(441.2 -452.09) rotate(62.99)",
    fill: "#3f3d56"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 563.18,
    y: 335.12,
    width: 20.12,
    height: 21.18,
    transform: "translate(1085.12 -11.13) rotate(123.99)",
    fill: "#3f3d56"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 402.62,
    y: 232.88,
    width: 20.12,
    height: 21.18,
    transform: "translate(738.64 -59.76) rotate(120.99)",
    fill: "#3f3d56"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 398.8,
    y: 329.42,
    width: 20.12,
    height: 21.18,
    transform: "matrix(0.5, 0.87, -0.87, 0.5, 403.55, -258.9)",
    fill: "#3f3d56"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 439.09,
    y: 199.76,
    width: 20.12,
    height: 21.18,
    transform: "translate(848.74 101.67) rotate(150.99)",
    fill: "#3f3d56"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 476.7,
    y: 379.55,
    width: 20.12,
    height: 21.18,
    transform: "translate(-81.4 -91.46) rotate(1.99)",
    fill: "#3f3d56"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 526.21,
    y: 369.02,
    width: 20.12,
    height: 21.18,
    transform: "translate(-212.04 232.91) rotate(-29.01)",
    fill: "#3f3d56"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 433.33,
    y: 365.79,
    width: 20.12,
    height: 21.18,
    transform: "translate(515.14 858.69) rotate(-147.01)",
    fill: "#3f3d56"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 384.73,
    y: 283.18,
    width: 24.36,
    height: 18,
    transform: "translate(-84.85 -88.4) rotate(1.99)",
    fill: "#3f3d56"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 576.3,
    y: 289.83,
    width: 24.36,
    height: 18,
    transform: "translate(1071.01 543.1) rotate(-178.01)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M271,733.91a20.66,20.66,0,0,0-7.09,2.21c-3,1.83-4.85,5.06-6.17,8.32-3.31,8.18-4,17.16-4.14,26-.12,7.12.12,14.41,2.67,21.05A13.3,13.3,0,0,0,259.8,797a12.56,12.56,0,0,0,4.83,2.34c3.8,1,8.21,1,11.32-1.4,3.46-2.71,4.33-7.48,5.06-11.81,1-5.84,2.39-12,6.73-16.07,3.22-3,7.83-4.5,10.17-8.22,2.79-4.42,1.32-10.19-.46-15.11-1.55-4.26-3.82-12.91-8.28-15.09S275.64,733.07,271,733.91Z",
    transform: "translate(-95.23 -74.8)",
    fill: "#fbbebe"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M435.47,754.86a33.45,33.45,0,0,1-7,12.91c-2,2.28-4.45,5.05-3.4,7.88a7.05,7.05,0,0,0,1.86,2.49c14.66,14.35,35.17,21.33,55.52,23.87a1.91,1.91,0,0,0,1,0c.6-.27.74-1,.82-1.67a21.13,21.13,0,0,0,0-6.4c-1-5-5.35-8.47-9.61-11.21s-8.92-5.4-11.3-9.87c-3-5.56-1.71-12.8-5.24-18-2.86-4.23-8.17-6-13.21-6.83-1.75-.27-5.47-2.19-7-1.3C436.35,747.63,436,753.12,435.47,754.86Z",
    transform: "translate(-95.23 -74.8)",
    fill: "#fbbebe"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M269,733.39a2,2,0,0,0-1.77-2,6.4,6.4,0,0,0-2.89.37,42.25,42.25,0,0,1-7,1.28c-2.81.27-5.68.26-8.41,1s-5.4,2.37-6.51,5a12.39,12.39,0,0,0-.72,4.69,71.64,71.64,0,0,0,2.18,18.21,1.58,1.58,0,0,0,.74,1.17c.35.14.77,0,1.12.16a1.48,1.48,0,0,1,.65.81c1.69,3.8,2.08,8,2.53,12.16q1,9.19,2.53,18.32c.6,3.55,1.34,7.28,3.68,10,2.56,3,6.62,4.29,10.53,4.82,8.26,1.1,16.6-.56,24.76-2.26a7.22,7.22,0,0,0,4.17-1.87,4.66,4.66,0,0,0,1-3.31c-.19-4.08-3.94-7-7.34-9.24l-4.68-3.15a2.43,2.43,0,0,1-.82-.74,2.64,2.64,0,0,1-.23-1.5l.3-6a17.18,17.18,0,0,0-15,9.31c-.65,1.29-1.26,2.8-2.61,3.3-1.67.63-3.53-.78-4.09-2.47a10.76,10.76,0,0,1,.15-5.28c2.74-14.68,2.1-29.77,3.77-44.61a10.16,10.16,0,0,1,1.49-4.7C267.34,735.74,268.85,734.76,269,733.39Z",
    transform: "translate(-95.23 -74.8)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M473.24,790.31c.69,1.14,1.76,2,2.4,3.18s.63,2.9-.52,3.57a3.52,3.52,0,0,1-2.16.22,73.1,73.1,0,0,1-39.53-17.88,27.71,27.71,0,0,1-4.84-5.31c-1.29-2-2.38-4.35-4.58-5.17a78.17,78.17,0,0,0-2,17.38c0,3.85.53,8.25,3.68,10.48a13.17,13.17,0,0,0,4.1,1.67l6.87,1.94a7.31,7.31,0,0,0,3.8.37c.81-.22,1.53-.73,2.36-.88a5.84,5.84,0,0,1,2.67.34l5.93,1.73a39.24,39.24,0,0,1,5.87,2c1.69.8,3.26,1.85,4.91,2.74a58.76,58.76,0,0,0,8.59,3.49l10.44,3.62a36.83,36.83,0,0,0,8.88,2.28c2.1.18,4.23,0,6.31.36,1.58.27,3.11.84,4.71,1a12.45,12.45,0,0,0,7.4-2.19,6.69,6.69,0,0,0,2.15-1.91c1.5-2.33.21-5.4-1.26-7.75-2.71-4.34-6.1-8.41-10.58-10.89-1.82-1-3.78-1.74-5.65-2.65-5.32-2.58-9.35-6.89-14.38-9.84C474.06,779.45,471,786.64,473.24,790.31Z",
    transform: "translate(-95.23 -74.8)",
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M326.61,370a43.25,43.25,0,0,1-18.46,7.18,74.46,74.46,0,0,1-10.45.56,265.8,265.8,0,0,1-43.46-3.63c5.72-6.3,11.5-13,13.66-21.26a34.92,34.92,0,0,0,.65-13.32,99.7,99.7,0,0,0-4.06-16.77,116.2,116.2,0,0,0,18.37-.47c3.48-.35,12-3.52,15-1.12,2.81,2.23.69,10.12.64,13.76,0,.13,0,.26,0,.39a44.28,44.28,0,0,0,3.51,16.06C306.41,361.22,315.82,369.3,326.61,370Z",
    transform: "translate(-95.23 -74.8)",
    fill: "#fbbebe"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M298.54,334.88a36.68,36.68,0,0,1-30,4.6,99.7,99.7,0,0,0-4.06-16.77,116.2,116.2,0,0,0,18.37-.47c3.48-.35,12-3.52,15-1.12C300.71,323.35,298.59,331.24,298.54,334.88Z",
    transform: "translate(-95.23 -74.8)",
    opacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 183.27,
    cy: 227.74,
    r: 36.6,
    fill: "#fbbebe"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M433.79,487.74a17,17,0,0,1-8.25,14.69,32.6,32.6,0,0,1-9,3.15c-16.74,4-33.89,7.29-51.08,6.31-3.72-.21-7.5-.65-10.84-2.28s-6.19-4.68-6.69-8.36a7.92,7.92,0,0,0-.53-2.66,7.5,7.5,0,0,0-2.54-2.26A10.41,10.41,0,0,1,341,486c-2.09.93-4.27-1.17-5.25-3.24s-1.75-4.57-3.85-5.44c-1.43-.61-3.08-.25-4.59-.64-2.41-.62-3.88-3-5.58-4.78-3.47-3.71-8.39-5.63-12.93-7.91-13.47-6.79-24.45-17.55-35.2-28.13-5.41-5.33-10.86-10.7-15.15-17-1.21-1.77-2.3-3.59-3.33-5.46a153.52,153.52,0,0,1-8.44-19.31c-1.36-3.54-2.74-7.28-2.18-11,.05-.34.12-.68.2-1a21.05,21.05,0,0,1,3.32-6.71c3.72-5.47,8.6-10.65,15-12.33s12.79.35,19.29,1.73a49.15,49.15,0,0,0,6.55,1c6.89.49,13.71-1.36,20.37-3.2l7.26-2c3.64-1,5.46-5.4,9.14-6.17a12.83,12.83,0,0,1,4.93.25c7.47,1.42,15,3.25,21.57,7.05a35.54,35.54,0,0,1,4.19,2.85c4.68,3.7,8.38,8.63,9.74,14.39,1.5,6.33.09,13.09,1.61,19.42,1.24,5.23,4.38,9.79,7.46,14.2L393,438.09a158.57,158.57,0,0,0,13.15,17.14C415.73,465.66,433.55,473.55,433.79,487.74Z",
    transform: "translate(-95.23 -74.8)",
    fill: "#35979C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M386.07,243.11c.74-3.49,1.29-7.15,3.22-10.16a23.21,23.21,0,0,1,4.73-5c3.07-2.59,6.33-5.08,10.14-6.34s8.29-1.09,11.49,1.33,4.55,6.59,5.05,10.57c.68,5.47,0,11.23-2.71,16-3.1,5.41-8.48,9-13,13.34a52,52,0,0,0-8.47,10.56,30.09,30.09,0,0,1-3.86,5.64,7.33,7.33,0,0,1-6.13,2.45c-1.92-.31-3.5-1.65-5-2.93-1.85-1.62-6.84-4.51-7-7.08-.12-2.08,3.77-6.8,4.72-8.75A99.19,99.19,0,0,0,386.07,243.11Z",
    transform: "translate(-95.23 -74.8)",
    fill: "#fbbebe"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M514.7,667.07c-4.6,8.49-9.64,16.76-13.74,25.5-2.39,5.11-4.46,10.37-7.12,15.34-2.9,5.42-6.47,10.46-9.5,15.82-7.63,13.51-11.88,28.75-15.81,43.76a87.17,87.17,0,0,1-31.16-11c-.65-.38-1.27-.78-1.87-1.21a22.24,22.24,0,0,1-6.29-6.93c3.63-13.73,7.36-27.69,14.75-39.82,2.41-4,5.17-7.65,7.65-11.55,7.19-11.3,8.67-25.56,16.88-36.14a6.21,6.21,0,0,0,0-7.36c-.95-1.23-2.46-2.4-2.18-3.92.21-1.11,1.37-2.11.92-3.15-.21-.5-.72-.77-1.12-1.13-1.4-1.29-1.22-3.49-1.34-5.38-.31-4.79-3.18-9-6-12.91a8,8,0,0,0-2.19-2.36c-.74-.45-1.62-.65-2.36-1.11-2.62-1.64-2.43-5.46-3.69-8.29-1.64-3.73-5.77-5.63-8.48-8.66-3.45-3.85-4.33-9.22-8-12.59a10,10,0,0,0-1.19-1c1.82,5.65,2,11.68,2.13,17.63.35,20.39-4.75,41.5-2.36,61.76,1.88,16.07-8,32.11-22.05,40.14-5.4,3.08-11.3,5.14-17.16,7.23-8.79,3.11-17.55,6.32-26.17,9.92q-9.14,3.78-18,8.15a227.43,227.43,0,0,0-21.29,11.78c-8.46,5.38-16.92,10.85-22.93,18.88-5.81-.16-11.13-3.65-14.81-8.15s-6-10-8.11-15.36c-1.87-4.65-3.71-9.45-3.85-14.46A2.86,2.86,0,0,1,280,728l40.17-21.29,7.51-4c16.45-8.73,33.49-16.8,49.94-25.52,1.11.33,2-.93,2.33-2s.56-2.45,1.6-2.93c.52-.25,1.2-.24,1.59-.68a1.9,1.9,0,0,0,.28-1.33c-.53-8-6.27-15.27-5.12-23.16.49-3.36,2.22-6.67,1.47-10-.53-2.29-2.17-4.14-3.06-6.31-2-4.85,0-10.69-2.16-15.44a35.7,35.7,0,0,1-2.9-9.84,66.83,66.83,0,0,0-6.14-19.5,35.55,35.55,0,0,0-5.65-8.55c-1.21-1.3-2.57-2.46-3.72-3.81-3.49-4.14-4.78-9.66-5.77-15-1.8-9.67-3-19.7-.8-29.28.76-3.27,1.92-6.51,1.87-9.86-.05-4.43-2-9.6,1.08-12.8a9.94,9.94,0,0,1,4.5-2.31c7.08-2.11,14.45-3.07,21.78-4L412.35,496c3.84-.51,7.77-1,11.16-2.91,4.55-2.51,7.57-7.16,9.42-12,5.89,4.3,8.09,12.31,12.79,17.86,2.29,2.71,5.12,4.9,7.63,7.39a85.62,85.62,0,0,1,8.41,10.37c7,9.61,14,19.29,19,30.07,2.61,5.6,4.63,11.44,6.71,17.25,8.19,22.87,21.54,44.58,27.08,68.22,1.36,5.78,4.89,11,5.44,16.91C520.61,655.43,517.71,661.49,514.7,667.07Z",
    transform: "translate(-95.23 -74.8)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M339,477.13a10.3,10.3,0,0,0-1.24,4.95c.75-3.7,5.84-5.75,6.17-9.41.15-1.69-.16-1.61-1.2-.72C341.15,473.32,340.46,475.68,339,477.13Z",
    transform: "translate(-95.23 -74.8)",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M354.51,488.37a7.63,7.63,0,0,0-2.32,3.43,8.7,8.7,0,0,0-.47,6c.75-.35,1-1.27,1.23-2.07a14.44,14.44,0,0,1,1.59-3.54c.6-1,3.37-3.23,3.36-4.28C357.87,486.3,355.25,487.8,354.51,488.37Z",
    transform: "translate(-95.23 -74.8)",
    opacity: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M356.3,364.49a37.74,37.74,0,0,1-7.72,5.14c-7.25,3.67-15.28,5.61-22.58,9.17a111.8,111.8,0,0,0-10.48,6.11l-21.7,13.75a23.27,23.27,0,0,0-4.78,3.63c-2.61,2.78-2.6,7.67-5,10.65s-6.54,4.66-10.53,4.86a34.21,34.21,0,0,1-11.73-2,60.9,60.9,0,0,1-6.7-2.44,31.57,31.57,0,0,1-6.44-3.68c-3.87-2.92-7-7.17-7.58-12a23.7,23.7,0,0,1,1.29-9.78,37.53,37.53,0,0,1,2.31-5.93,23.86,23.86,0,0,1,1.84-3.12c5-7.06,13.77-10.37,22.26-12,4.46-.87,9-1.4,13.51-2.16a49.15,49.15,0,0,0,6.55,1c6.89.49,13.71-1.36,20.37-3.2l7.26-2c3.64-1,5.46-5.4,9.14-6.17a12.83,12.83,0,0,1,4.93.25c7.47,1.42,15,3.25,21.57,7.05A35.54,35.54,0,0,1,356.3,364.49Z",
    transform: "translate(-95.23 -74.8)",
    opacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M374,267.35c-.93,8.85-8.4,15.35-13,23-2.21,3.71-3.76,7.78-5.75,11.62a115.18,115.18,0,0,1-7.6,12.1l-8.13,11.8c-4.78,6.94-9.61,13.94-15.72,19.75-10.65,1.81-19.58,9.72-29.68,13.56-8.08,3.07-16.89,3.49-25.37,5.14s-17.27,5-22.25,12a31.41,31.41,0,0,0-4.16,9,23.32,23.32,0,0,0-1.28,9.77c.61,4.82,3.7,9.06,7.57,12s8.5,4.68,13.14,6.12a34.45,34.45,0,0,0,11.73,2c4-.2,8.06-1.74,10.54-4.86s2.36-7.87,5-10.65a23.34,23.34,0,0,1,4.79-3.63l21.7-13.75A111.8,111.8,0,0,1,326,376.25c7.3-3.57,15.33-5.5,22.58-9.17s14-9.73,15.45-17.73c4.42-24.58,21.43-45.3,36-65.6-.48-.1-.33-1.19-.51-1.65-1.86-4.82-6-8.45-10.66-10.74S379,268.43,374,267.35Z",
    transform: "translate(-95.23 -74.8)",
    fill: "#35979C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M297.28,267.53a13.56,13.56,0,0,0-1.51-7.72c-2.41-4-7.46-5.41-12-6.35q-6.59-1.35-13.24-2.32c-3.64-.53-7.37-1-10.95-.18-5,1.09-9.07,4.4-13.7,6.46-5.47,2.44-11.53,3.08-17.37,4.43s-11.82,3.64-15.48,8.38c-2.78,3.6-3.89,8.2-4.72,12.68-6.93,37.39.53,75.74,1.95,113.74.55,14.79-.12,30.6-8.57,42.75l24.61-.65c6.3-.16,13.07-.49,18-4.38,4.36-3.42,6.42-8.93,8.29-14.15,1.47-4.11,2.95-8.3,3.14-12.66.39-8.93-4.68-17.7-3-26.49,1.23-6.56,6-11.86,11.11-16.17s10.79-8,14.92-13.28c7.38-9.33,8.79-22.08,7.87-33.93-.55-7.05-1.81-14.1-1.2-21.15.46-5.27,2.13-10.71,5.58-14.82C294.89,277.06,296.94,274.14,297.28,267.53Z",
    transform: "translate(-95.23 -74.8)",
    fill: "#3f3d56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M295.77,259.81c-2.37-3.94-7.29-5.36-11.8-6.3a11.63,11.63,0,0,1,5.84,4.6,13.48,13.48,0,0,1,1.51,7.72c-.34,6.6-2.39,9.52-6.31,14.19-3.45,4.11-5.12,9.54-5.58,14.82-.61,7.05.65,14.1,1.2,21.15.92,11.85-.49,24.6-7.86,33.93-4.14,5.24-9.82,9-14.92,13.28s-9.89,9.61-11.12,16.17c-1.65,8.79,3.42,17.56,3,26.49-.19,4.36-1.68,8.55-3.15,12.66-1.86,5.22-3.93,10.72-8.29,14.14-5,3.89-11.73,4.23-18,4.39l-17.43.46c-.39.64-.79,1.28-1.22,1.89l24.61-.65c6.3-.16,13.07-.49,18-4.38,4.36-3.42,6.42-8.93,8.29-14.15,1.47-4.11,2.95-8.3,3.14-12.66.39-8.93-4.68-17.7-3-26.49,1.23-6.56,6-11.86,11.11-16.17s10.79-8,14.92-13.28c7.38-9.33,8.79-22.08,7.87-33.93-.55-7.05-1.81-14.1-1.2-21.15.46-5.27,2.13-10.71,5.58-14.82,3.92-4.66,6-7.58,6.31-14.19A13.56,13.56,0,0,0,295.77,259.81Z",
    transform: "translate(-95.23 -74.8)",
    opacity: 0.1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M480.67,645.18,435.5,755.33a22.24,22.24,0,0,1-6.29-6.93c3.63-13.73,7.36-27.69,14.75-39.82,2.41-4,5.17-7.65,7.65-11.55,7.19-11.3,8.67-25.56,16.88-36.14a6.21,6.21,0,0,0,0-7.36c-.95-1.23-2.46-2.4-2.18-3.92.21-1.11,1.37-2.11.92-3.15-.21-.5-.72-.77-1.12-1.13-1.4-1.29-1.22-3.49-1.34-5.38-.31-4.79-3.18-9-6-12.91a8,8,0,0,0-2.19-2.36c-.74-.45-1.62-.65-2.36-1.11-2.62-1.64-2.43-5.46-3.69-8.29-1.64-3.73-5.77-5.63-8.48-8.66-3.45-3.85-4.33-9.22-8-12.59l-.31-.78L437.26,572Z",
    transform: "translate(-95.23 -74.8)",
    opacity: 0.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.155b6b7bb90aad668ff5e068e026031f.svg";
export { ForwardRef as ReactComponent };